export default __webpack_public_path__ + "b65ed74e9279ec7be82c0cf4dd7a8fdd.svg";